module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACiAgMAAAD9340fAAAADFBMVEWAs0AAAACCpk2IrEK92oEwAAAABHRSTlMUAAYO3Qos0wAAAGVJREFUWMPt1sEJgDAMQNFAZ+lIikc36DQu0SGtFyWaKAEpPf1/fgN8maL+i0XOEsKIatqcsGUEAoFAIBB9xFyvvoSGiK4PgQhEadr+KlbRUiz8STthywgEAoFAIBAPUdqtMSd9AMnVhjONGOr8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/partners/gray-7.png
// module id = IdV5
// module chunks = 3